module.exports = __webpack_public_path__ + "img/lock.75f3d1a4.png";